export const natMap = {
AD: "Andorran",
AE: "Emirian",
AF: "Afghan",
AG: "Antiguan or Barbudan",
AI: "Anguillan",
AL: "Albanian",
AM: "Armenian",
AO: "Angolan",
AQ: "Antarctic",
AR: "Argentine",
AS: "American Samoan",
AT: "Austrian",
AU: "Australian",
AW: "Aruban",
AX: "Åland Island",
AZ: "Azerbaijani",
BA: "Bosnian",
BB: "Barbadian",
BD: "Bangladeshi",
BE: "Belgian",
BF: "Burkinabé",
BG: "Bulgarian",
BH: "Bahraini",
BI: "Burundian",
BJ: "Beninese",
BL: "Barthélemois",
BM: "Bermudian, Bermudan",
BN: "Bruneian",
BO: "Bolivian",
BQ: "Bonaire",
BR: "Brazilian",
BS: "Bahamian",
BT: "Bhutanese",
BV: "Bouvet Island",
BW: "Motswana, Botswanan",
BY: "Belarusian",
BZ: "Belizean",
CA: "Canadian",
CC: "Cocos Island",
CD: "Congolese",
CF: "Central African",
CG: "Congolese",
CH: "Swiss",
CI: "Ivorian",
CK: "Cook Island",
CL: "Chilean",
CM: "Cameroonian",
CN: "Chinese",
CO: "Colombian",
CR: "Costa Rican",
CU: "Cuban",
CV: "Cabo Verdean",
CW: "Curaçaoan",
CX: "Christmas Island",
CY: "Cypriot",
CZ: "Czech",
DE: "German",
DJ: "Djiboutian",
DK: "Danish",
DM: "Dominican",
DO: "Dominican",
DZ: "Algerian",
EC: "Ecuadorian",
EE: "Estonian",
EG: "Egyptian",
EH: "Sahrawian",
ER: "Eritrean",
ES: "Spanish",
ET: "Ethiopian",
FI: "Finnish",
FJ: "Fijian",
FK: "Falkland Island",
FM: "Micronesian",
FO: "Faroese",
FR: "French",
GA: "Gabonese",
GB: "British",
GD: "Grenadian",
GE: "Georgian",
GF: "French Guianese",
GG: "Channel Island",
GH: "Ghanaian",
GI: "Gibraltar",
GL: "Greenlandic",
GM: "Gambian",
GN: "Guinean",
GP: "Guadeloupe",
GQ: "Equatoguinean",
GR: "Greek",
GS: "South Sandwich Islands",
GT: "Guatemalan",
GU: "Guamanian",
GW: "Bissau-Guinean",
GY: "Guyanese",
HK: "Hong Kongese",
HM: "Heard Island",
HN: "Honduran",
HR: "Croatian",
HT: "Haitian",
HU: "Magyar",
ID: "Indonesian",
IE: "Irish",
IL: "Israeli",
IM: "Manx",
IN: "Indian",
IO: "BIOT",
IQ: "Iraqi",
IR: "Iranian",
IS: "Icelandic",
IT: "Italian",
JE: "Channel Island",
JM: "Jamaican",
JO: "Jordanian",
JP: "Japanese",
KE: "Kenyan",
KG: "Kyrgyzstani",
KH: "Cambodian",
KI: "I-Kiribati",
KM: "Comorian",
KN: "Nevisian",
KP: "North Korean",
KR: "South Korean",
KW: "Kuwaiti",
KY: "Caymanian",
KZ: "Kazakh",
LA: "Laotian",
LB: "Lebanese",
LC: "Saint Lucian",
LI: "Liechtenstein",
LK: "Sri Lankan",
LR: "Liberian",
LS: "Basotho",
LT: "Lithuanian",
LU: "Luxembourgish",
LV: "Latvian",
LY: "Libyan",
MA: "Moroccan",
MC: "Monacan",
MD: "Moldovan",
ME: "Montenegrin",
MF: "Saint-Martinoise",
MG: "Malagasy",
MH: "Marshallese",
MK: "Macedonian",
ML: "Malinese",
MM: "Burmese",
MN: "Mongolian",
MO: "Chinese",
MP: "Northern Marianan",
MQ: "Martiniquais",
MR: "Mauritanian",
MS: "Montserratian",
MT: "Maltese",
MU: "Mauritian",
MV: "Maldivian",
MW: "Malawian",
MX: "Mexican",
MY: "Malaysian",
MZ: "Mozambican",
NA: "Namibian",
NC: "New Caledonian",
NE: "Nigerien",
NF: "Norfolk Island",
NG: "Nigerian",
NI: "Nicaraguan",
NL: "Netherlandic",
NO: "Norwegian",
NP: "Nepalese",
NR: "Nauruan",
NU: "Niuean",
NZ: "New Zealander",
OM: "Omani",
PA: "Panamanian",
PE: "Peruvian",
PF: "French Polynesian",
PG: "Papuan",
PH: "Filipino",
PK: "Pakistani",
PL: "Polish",
PM: "Miquelonnais",
PN: "Pitcairn Island",
PR: "Puerto Rican",
PS: "Palestinian",
PT: "Portuguese",
PW: "Palauan",
PY: "Paraguayan",
QA: "Qatari",
RE: "Réunionese",
RO: "Romanian",
RS: "Serbian",
RU: "Russian",
RW: "Rwandan",
SA: "Saud",
SB: "Solomon Island",
SC: "Seychellois",
SD: "Sudanese",
SE: "Swedish",
SG: "Singaporean",
SH: "Saint Helenian",
SI: "Slovenian",
SJ: "Svalbard",
SK: "Slovak",
SL: "Sierra Leonean",
SM: "Sammarinese",
SN: "Senegalese",
SO: "Somalian",
SR: "Surinamese",
SS: "South Sudanese",
ST: "São Toméan",
SV: "Salvadoran",
SX: "Sint Maarten",
SY: "Syrian",
SZ: "Swazi",
TC: "T&C Islander",
TD: "Chadian",
TF: "FS Territories",
TG: "Togolese",
TH: "Thai",
TJ: "Tajikistani",
TK: "Tokelauan",
TL: "Timorese",
TM: "Turkmen",
TN: "Tunisian",
TO: "Tongan",
TR: "Turkish",
TT: "Trinidadian",
TV: "Tuvaluan",
TW: "Taiwanese",
TZ: "Tanzanian",
UA: "Ukrainian",
UG: "Ugandan",
UM: "American",
US: "American",
UY: "Uruguayan",
UZ: "Uzbek",
VA: "Vatican",
VC: "Vincentian",
VE: "Venezuelan",
VG: "BV Island",
VI: "U.S.V. Island",
VN: "Vietnamese",
VU: "Vanuatuan",
WF: "Futunan",
WS: "Samoan",
YE: "Yemeni",
YT: "Mahoran",
ZA: "South African",
ZM: "Zambian",
ZW: "Zimbabwean",
}